import React from 'react';
import { Pressable, StyleSheet, TextInput, View } from 'react-native';
import { Text } from './Texte';
import { MONTHS } from '../utils/monthYear';
import { colors, radius, spacing, typography } from '../theme/tokens';
import type { MonthYear } from '../types';
import { t } from '../i18n';

interface MonthYearFieldProps {
  value: MonthYear;
  onChange: (value: MonthYear) => void;
  testID?: string;
}

// Sélection simple mois (chips) + année (champ numérique) — pas de calendrier.
export function MonthYearField({ value, onChange, testID }: MonthYearFieldProps) {
  return (
    <View testID={testID} style={styles.container}>
      <View style={styles.months}>
        {MONTHS.map((label, index) => {
          const month = String(index + 1);
          const active = value.month === month;
          return (
            <Pressable
              key={month}
              testID={testID ? `${testID}-m${month}` : undefined}
              accessibilityRole="button"
              accessibilityState={{ selected: active }}
              onPress={() => onChange({ ...value, month: active ? '' : month })}
              style={[styles.chip, active && styles.chipActive]}
            >
              <Text style={[styles.chipText, active && styles.chipTextActive]}>{label}</Text>
            </Pressable>
          );
        })}
      </View>
      <TextInput
        testID={testID ? `${testID}-year` : undefined}
        style={styles.year}
        placeholder={t('misc.yearPlaceholder')}
        placeholderTextColor={colors.grey400}
        keyboardType="number-pad"
        maxLength={4}
        value={value.year}
        onChangeText={(year) => onChange({ ...value, year: year.replace(/[^0-9]/g, '') })}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { gap: spacing.sm },
  months: { flexDirection: 'row', flexWrap: 'wrap', gap: spacing.xs },
  chip: {
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    borderRadius: radius.pill,
    backgroundColor: colors.grey100,
  },
  chipActive: { backgroundColor: colors.bluePrimary },
  chipText: { fontSize: typography.caption.size, color: colors.grey700 },
  chipTextActive: { color: colors.white },
  year: {
    width: 96,
    height: 40,
    borderWidth: 1,
    borderColor: colors.grey200,
    borderRadius: radius.sm,
    paddingHorizontal: spacing.md,
    fontSize: typography.body.size,
    color: colors.grey900,
    backgroundColor: colors.white,
  },
});
